import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './HelpBlock.module.scss';

interface HelpBlockProps {
  className?: string;
  content: string;
}

const HelpBlock = ({ className, content }: HelpBlockProps) => {
  const { t } = useTranslation(['common']);

  return (
    <section className={classNames(styles.helpBlock, className)}>
      <h4 className={styles.title}>{t('common:needHelp')}</h4>
      <div className={styles.content}>{content}</div>
    </section>
  );
};

export default HelpBlock;
